import { Component, Input, ViewChild } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { ITranslations } from "../../_models/ITranslations";
import { TranslationService } from "../../_services/translation.service";
import { SelectMenuOption } from "../../form/select-menu/select-menu.component";
import { MultiSelectNestsComponent } from "../../common/multi-select-nests/multi-select-nests.component";

@Component({
  selector: "dev-select-menu-component",
  template: `
    <div dir="rtl" class="menu-limiter">
      <multi-select-menu
        (select-menu-event)="menuEventSelection($event)"
        [(ngModel)]="EventTypeSelect"
        [menuOptions]="selectMenuOptions"
        appearance="no-limit"
        id="event-type-select"
        length="300"
      ></multi-select-menu>

      <div class="margin-top-90">
        <multi-select-nests #multiSelectCircles></multi-select-nests>
      </div>
    </div>
  `,
  styles: [
    `
      .menu-limiter {
        width: 300px;
        margin: 0 auto;
      }
      .margin-top-90 {
        margin-top: 90px;
      }
    `,
  ],
})
export class DevSelectMenuComponent {
  public selectMenuOptions: SelectMenuOption[] = [
    { key: "1", text: "טיול", customValue: "" },
    { key: "2", text: "פסחת", customValue: "" },
    { key: "3", text: "קריות", customValue: "" },
    { key: "4", text: "מסי קן", customValue: "" },
    { key: "5", text: "שכבת החוות", customValue: "" },
    { key: "6", text: "מצעד הגאווה", customValue: "" },
    { key: "7", text: "טיול יפה", customValue: "" },
    { key: "8", text: "טיול גדול", customValue: "" },
    { key: "9", text: "טיול מדהים", customValue: "" },
    { key: "10", text: "טיול פסח", customValue: "" },
    { key: "11", text: "טיול חנוכה", customValue: "" },
    { key: "12", text: "מסיבת גאווה", customValue: "" },
    { key: "13", text: "טיול בוץ", customValue: "" },
    { key: "14", text: "טיול יער", customValue: "" },
    { key: "15", text: "טיול לירדן", customValue: "" },
    { key: "16", text: "טיול לירושליים", customValue: "" },
    { key: "17", text: "טיול פורים", customValue: "" },
    { key: "18", text: "טיול מיוחד", customValue: "" },
    { key: "19", text: "טיול עם שם ארוך מאד", customValue: "" },
    { key: "20", text: "סמינר טיול", customValue: "" },
    { key: "21", text: "טיול סמינר", customValue: "" },
    { key: "22", text: "סמינר גאווה", customValue: "" },
    { key: "23", text: "סמינר גאווה", customValue: "" },
  ];
  // @ViewChild("multiSelectCircles")
  // public multiSelectCircles: MultiSelectNestsComponent;
  public translations$: Observable<ITranslations>;
  public EventTypeSelect: any;

  constructor(private translationService: TranslationService) {
    this.translations$ = this.translationService.translations;
  }
  public menuEventSelection(event: any) {}
}



// WEBPACK FOOTER //
// ./src/app/development/ui/dev-select-menu.component.ts